
import { Component, render, createRef } from 'preact';
import { Button } from '@rmwc/button';
import { TabBar, Tab } from '@rmwc/tabs';
import { Grid, GridCell, GridRow } from '@rmwc/grid';
import { TextField } from '@rmwc/textfield';
import { Theme, ThemeProvider } from '@rmwc/theme';
import '@rmwc/theme/styles';
import '@rmwc/button/styles';
import '@rmwc/tabs/styles';
import '@rmwc/grid/styles';
import '@rmwc/textfield/styles';

import MapMapTalks from '/components/map_maptalks.jsx';
import ConfigHeatmapSimple from '/components/configs/heatmap_simple.jsx';
import { style } from 'glamor'
import './index.css';

import GapiTool from './GapiTool.js';

import Common from '/common.jsx';

import GraphWindow from './components/graph_window';

function download(content, fileName, contentType) {
    var a = document.createElement("a");
    var file = new Blob([content], {type: contentType});
    a.href = URL.createObjectURL(file);
    a.download = fileName;
    a.click();
}

class App extends Common {

    state = { 
        init: false,
        tokenClient: null, 
        gapiInited: false, 
        gisInited: false,
        outdata: "test",
        showSlideDownDiv: true,
        current_tab: 0,
        ga_gps_json: null,
        graph_data: {
            labels: ['One', 'Two', 'Three',],
            datasets: [
              {
                label: '# of Locations Visited',
                data: [0,0,0],
                backgroundColor: [
                  'rgba(255, 99, 132, 0.2)',
                  'rgba(54, 162, 235, 0.2)',
                  'rgba(255, 206, 86, 0.2)',
                ],
                borderColor: [
                  'rgba(255, 99, 132, 1)',
                  'rgba(54, 162, 235, 1)',
                  'rgba(255, 206, 86, 1)',
                ],
                borderWidth: 1,
              },
            ],
          },
        input: {
                map_provider:'Carto Dark',
                map_recenter: false,
                hm_prec:100000,
                hm_scale:25,
                hm_time:-0.1,
                hm_time_padding:10.0,
                gapi_view_id:'282943666',
                gapi_date_start:'2023-02-03',
                gapi_date_end:'2023-02-13',
                hm_date_start:'2023-02-11T19:00',
                hm_date_end:'2023-02-12T23:50',
                hm_time_range: [0,1],
            },
    }

    handle_tab_change = (index) => {
        if (index != this.state.current_tab){
            //console.log(index);
            this.setState({current_tab:index});
        }
    }
    
    handle_input = (input) => {
        console.log(`input: ${Object.keys(input)[0]}:${Object.values(input)[0]}`);
        const that = this;
        this.setState({input:{
            ...this.state.input,
            ...input,
        }});

        if (input.gapi_date_start != undefined){
            localStorage.setItem("gapi_date_start", input.gapi_date_start);
        }
        if (input.gapi_date_end != undefined){
            localStorage.setItem("gapi_date_end", input.gapi_date_end);
        }

        this.input = this.state.input;
    }   

    get_input = (input=null) => {
        if (input==null){
            return this.state.input;
        }
        return this.state.input[input];
    }

    update_graph_data = (graph_data) => {
        this.setState({graph_data:graph_data});
    }

    update_gps_data = (gps_data) => {
        //download(JSON.stringify(gps_data), 'json.txt', 'text/plain');
        this.setState({ga_gps_json:gps_data});
        console.log(gps_data);
    }

    componentWillMount() {
        const that = this;
        this.gapi_tool = new GapiTool(this.state.input, this.update_gps_data);
        this.gapi_tool.ready_callback = () => {
            console.log("gapi ready");
            that.setState({gapi_ready:true});
        }
        this.gapi_tool.get_input = this.get_input;

        if (localStorage.getItem("gapi_date_start") != undefined && localStorage.getItem("gapi_date_end") != undefined){
        this.setState({input:{
            ...this.state.input,
            gapi_date_start:localStorage.getItem("gapi_date_start"),
            gapi_date_end:localStorage.getItem("gapi_date_end"),
        }});
        }

        that.input = that.state.input;

    }

    componentDidMount() {
        const that = this;

        this.update_gps_data(JSON.parse(localStorage.getItem("ga_gps_json")));

        //fetch('./assets/json_data_hack.json')
        //.then((response) => response.json())
        //.then((json) => this.update_gps_data(json));


        that.setState({init:true});
        

        console.log(that.input);
    }
    file_input_ref = createRef();
    open_file_dialog = () => {
        this.file_input_ref.current.click();
    };

    render() {
        const that = this.state;
        const the = this;
        const handle_input = this.handle_input;
        const get_input = this.get_input;
        const input_new = this.state.input;
        const input = input_new;
        const tabs = [
            { label: 'GAPI', content: 
            
                <Grid {...styles.grid}>
                     
                        < GridCell span={3}>                
                            <TextField  
                            {...styles.textField}
                            outlined
                            label="View ID"                  
                            value={input.gapi_view_id}
                            onInput={e => handle_input({ view_id: e.target.value })}
                            />
                            <Button 
                            {...styles.padded}
                            raised
                            onClick={e => this.gapi_tool.retrieve_analytics()}
                            disabled={!(that.gapi_ready)}
                            >{(that.gapi_ready) ? 'Retrieve Analytics' : 'Loading...'}</Button>
                        </ GridCell>
                        
                        < GridCell span={3} >
                            <TextField
                                {...styles.textField}
                                outlined
                                label="Query Date Start" type="date"
                                value={input.gapi_date_start}
                                onChange={e => handle_input({gapi_date_start:e.target.value})}
                            />
                            <TextField
                                {...styles.textField}
                                outlined
                                label="Query Date End" type="date"
                                value={input.gapi_date_end}
                                onChange={e => handle_input({gapi_date_end:e.target.value})}
                            />
                        </ GridCell> 
                        < GridCell span={3} >
                        <input
                            type="file"
                            style={{ display: 'none' }}
                            ref={the.file_input_ref}
                            onChange={e => this.gapi_tool.handle_file_upload(e)}
                        />
                        <Button onClick={the.open_file_dialog}>Upload File</Button>
                        </GridCell>
                     
                </Grid>     
            },
            { label: 'Tab 2', content: 
                <ConfigHeatmapSimple handle_input={handle_input} input={input} styles={styles} map_data={that.map_data}/>
            },
        ];

        return(
            
            <main {...styles.main}>


                <div {...styles.viewport} >
                    {/*<MapLeaflet ga_gps_json={that.ga_gps_json} input_new={that.input}/>*/}
                    <MapMapTalks handle_input={handle_input} ga_gps_json={that.ga_gps_json} input={input} update_graph_data={the.update_graph_data}/>
                </div>
                <div {...(that.showSlideDownDiv ? styles.show : styles.pullMenu)} >
                    <div {...styles.pullMenuInner}>
                        <TabBar>
                            <Tab  {...styles.tab} active onClick={()=>this.handle_tab_change(0)}>
                                 
                                    <span class="material-icons">manage_accounts</span> GAPI
                                 
                            </Tab>
                            <Tab  {...styles.tab} onClick={()=>this.handle_tab_change(1)}>
                                 
                                    <span class="material-icons">settings</span> Config
                                     
                            </Tab>
                        </TabBar>
                        {tabs[that.current_tab].content}
                        <Button 
                            ripple={false} raised outlined
                            {...styles.pullButton} 
                            onClick={e => the.setState({showSlideDownDiv:!that.showSlideDownDiv })}
                        >
                            <span class="mdc-button__ripple"></span>
                            <i class="material-icons mdc-button__icon" aria-hidden="true">
                            expand_more
                            </i>
                        </Button>
                    </div>
                </div>
                <GraphWindow data={that.graph_data}/>

            </main>

        );

	}
}

const col_bg = 'rgb(28, 17, 37)';
const col_theme_2 = 'rgb(233, 163, 204)';

const drawer_size = 35;

const styles = {
    
    main: style({
        backgroundColor: col_bg,
        overflowY: 'hidden',
        overflowX: 'hidden',
        padding: '0',
        margin: '0',
        width: '100%',
        maxWidth:'100%',
        height: '100%',
    }),

    viewport: style({
        backgroundColor: col_bg,
        height: '100vh',
        padding: '0px',
        margin: '0px',
        overflowY: 'hidden',
    }),

    grid: style({
        backgroundColor: 'col_bg',
        overflowY: 'scroll',
        height: `${drawer_size}vh`,
    }),

    pullMenu: style({         
        backgroundColor: col_bg,
        position: 'absolute',
        top: '0',
        left: '0',
        width: '80%',
        height: `${drawer_size}vh`,
        padding: '0 2vw',
        transition: 'transform 0.5s ease',
        transform: `translate(8%, -${drawer_size}vh)`, 
        overflowY: 'visible',
        margin: '0 2vw',
        padding: '0 2vw',
    }),


    pullMenuInner: style({         
        backgroundColor: col_bg,
        width: '100%',
        height: '100%',
        maxWidth: '100%',
        maxHeight: '100%',
        margin: '0',
        padding: '0',
        overflowY: 'hidden',
        overflowX: 'hidden',
    }),

    show: style({         
        backgroundColor: col_bg,
        position: 'absolute',
        top: '0',
        left: '0',
        width: '80%',
        height: `${drawer_size}vh`,
        transition: 'transform 0.5s ease',
        transform: 'translateY(-0%)', 
        transform: 'translateX(10%)', 
        overflowY: 'visible',
        margin: '0 2vw',
        padding: '0 2vw',
    }),

    pullButton: style({
        position: 'absolute',
        top: `${drawer_size+2}vh`,
        overflow: 'visible',
        color: 'red'
    }),

    textField: style({
        color:'white',
        borderColor:'white',
        backgroundColor:'white',

    }),

    padded: style({
        margin: '15px',
        padding: '15px',
    }),
    canvas: style({
        width:'100%',
        height:'100%',
    }),
    tab: style({
        maxWidth:'47%',
    }),
    select: style({
        width:'100%',
        margin:'10',
    }),
    slider_continuous: style({
        margin:'0',
        padding:'0',
    }),
}

if (typeof window !== "undefined") {
    render(<App/>, document.body);
}

